/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/survey/question/chart" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSurveyQuestionChart } from "./constants";
import type { EngagementSurveyQuestionChartArgs, EngagementSurveyQuestionChartResult } from "./types";
import { isEngagementSurveyQuestionChartResult } from "./validators";

export const getEngagementSurveyQuestionChart = reactQueryFetcherAdapter(
  engagementSurveyQuestionChart,
  (
    signal: AbortSignal,
    {
      appGroupId,
      questionId,
      campaignBaseId,
      messageVariationId,
      landingPageId,
      startDate,
      endDate,
    }: EngagementSurveyQuestionChartArgs
  ): Promise<EngagementSurveyQuestionChartResult> => {
    return fetch(
      `/engagement/${appGroupId}/survey/question/chart`,
      "GET",
      {
        question_id: questionId,
        campaign_base_id: campaignBaseId,
        message_variation_id: messageVariationId,
        landing_page_id: landingPageId,
        start_date: startDate,
        end_date: endDate,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isEngagementSurveyQuestionChartResult
);
